"use client";

import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "@/lib/query-keys";

import { authRepository } from "@/features/auth/api/auth-repository";

/**
 * Fetches a captcha image + session token, only when `enabled` (i.e. the site
 * requires one). `refresh()` pulls a fresh challenge — call it after a failed
 * submit, since the backend consumes the token. Never cached/retried (each
 * challenge is single-use).
 */
export function useCaptcha(enabled: boolean) {
  const query = useQuery({
    queryKey: queryKeys.auth.captcha(),
    queryFn: () => authRepository.getCaptcha(),
    enabled,
    staleTime: 0,
    gcTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
  });
  return { captcha: query.data, refresh: query.refetch };
}
